module.exports = __webpack_public_path__ + "img/ai-companion.5dca0af1.svg";